import clienteAxios from "../../helpers/clienteAxios";

export const useIniciarSesion = async (form) => {
    const { data } = await clienteAxios.post('/sucursalVirtual/login-clientes',form);
    return data;
}